import { render, staticRenderFns } from "./LegendRadar.vue?vue&type=template&id=7dac6f66&"
import script from "./LegendRadar.vue?vue&type=script&lang=js&"
export * from "./LegendRadar.vue?vue&type=script&lang=js&"
import style0 from "./LegendRadar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports